import React, { useState, useEffect } from "react";
import { KofiCommissionsList } from "./CommissionsTemplate";
import { get_kofi_commissions_cache } from "../../services/totoservice";
import { LoadingViewPlacholder, ErrorViewPlaceholder } from '../Template'

const Commissions = () => {

    const [commissions, setCommissions] = useState([])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleApiSuccess = (commissions_data) => {
        console.log('handleApiSuccess called with commissions_data =' + JSON.stringify(commissions_data))
        setCommissions(commissions_data)
        setLoading(false);
    }

    const handleApiError = (err) => {
        console.log('handleApiError called with err =' + err)
        setError(err);
        setLoading(false);
    }

    async function fetchCommissions() {
        await get_kofi_commissions_cache(handleApiSuccess, handleApiError)
    }

    useEffect(() => {
        fetchCommissions()
    }, []);


    if (loading) return <LoadingViewPlacholder title={"Loading commissions from Ko-fi"} />;
    else if (error) return <ErrorViewPlaceholder title="Error getting commissions data from Ko-fi" details="Please try again later" />;
    return (
        <main className="kofi-background main-layout">
            <h1>Commissions</h1>
            <div className="main-content-container">
                <KofiCommissionsList items={commissions} />
            </div>
        </main>
    );
}

export default Commissions;